import {CommonModule} from '@angular/common';
import {HttpErrorResponse} from '@angular/common/http';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ActionFinishedModule} from '@aztrix/components/action-finished';
import {ButtonModule} from '@aztrix/components/button';
import {OverlayService} from '@aztrix/components/overlay';
import {hasVerification} from '@aztrix/helpers';
import {
  AgreementRepresentation,
  ProposalLanguageRepresentation,
  ProposalRepresentation,
} from '@aztrix/sdk';
import {AgreementVerificationComponent} from '@aztrix/subscribe/agreement-view';
import {TranslatePipe} from '@aztrix/translate';

@Component({
  selector: 'ax-after-subscribe',
  standalone: true,
  imports: [
    CommonModule,
    AgreementVerificationComponent,
    ButtonModule,
    ActionFinishedModule,
    TranslatePipe,
  ],
  templateUrl: './after-subscribe.component.html',
  styleUrl: './after-subscribe.component.scss',
})
export class AfterSubscribeComponent {
  @Input() proposal?: ProposalRepresentation;
  @Input() language?: ProposalLanguageRepresentation;
  @Input() agreement?: AgreementRepresentation;
  @Input() payed = false;
  @Input() external = false;
  @Input() subscribedSuccess = false;
  @Input() verificationSuccess = false;
  @Input() autoVerification = true;

  @Output() verified = new EventEmitter();
  @Output() confirmSuccess = new EventEmitter();
  @Output() verificationError = new EventEmitter<HttpErrorResponse>();
  @Output() resendSuccess = new EventEmitter<AgreementRepresentation>();

  constructor(private _overlayService: OverlayService) {}

  get hasProducts(): boolean {
    return !!this.proposal?.product;
  }

  get successMessage() {
    return this.language?.successMessage;
  }

  get needsVerification() {
    return hasVerification(this.proposal) && !this.agreement?.verified;
  }

  success() {
    this.confirmSuccess.emit();
  }

  closeModal() {
    this._overlayService.closeModal();
  }

  verificationCompleted(agreement: AgreementRepresentation) {
    if (this.agreement) {
      this.agreement = agreement;
    }
    this.verified.emit(agreement);
    this.verificationSuccess = true;
  }
}
